<template>
    <div class="registrationTabs-nav">
        <div class="row">
            <div
                v-for="(tab, key) in tabs"
                :key="key"
                class="col d6 registrationTabs-tab"
                :class="{'active': currentTab === tab.code}"
                @click="setType(tab.code)"
            >
                <div class="registrationTabs-tab-inner">
                    <img class="registrationTabs-tab-icon"
                         :src="tab.image"
                         alt=""
                    >
                    <div class="registrationTabs-tab-title">{{ tab.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useTabsValue from "../../../composables/useTabsValue";
import ATabs from "../../ui/ATabs";

export default {
    name: "AuthTabs",
    extends: ATabs,
    emits: ['changeTab'],
    setup(props, ctx) {
        const {currentTab} = useTabsValue(props, ctx)

        const setType = code => {
          currentTab.value = code;
          ctx.emit('changeTab',code);
        }

        return {
            setType,
            currentTab
        }
    }
}
</script>

<style scoped>

</style>